module.exports = __webpack_public_path__ + "static/media/bg_white_left.d2e05114.png";